<template>
  <div
    class="Media-menu u-floatRight"
  >
    <ul>
      <template v-if="shouldShowMediaMenu">
        <li @click="handleChangeMedia">
          Change media
        </li>
        <li
          class="RemoveMedia"
          @click="handleRemoveMedia"
        >
          Remove media
        </li>
      </template>
      <template v-if="question.type === 'statement'">
        <li @click="handleSetAlignment('text-align-left')">
          <span class="Icon Icon-align-left" />Text left align
        </li>
        <li @click="handleSetAlignment('text-align-right')">
          <span class="Icon Icon-align-right" />Text right align
        </li>
        <li @click="handleSetAlignment('text-align-center')">
          <span class="Icon Icon-align-center" />Text centre align
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MediaMenu',

  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  computed: {
    shouldShowMediaMenu() {
      return this.question.layout ? this.question.layout.type !== 'text-only' : false;
    },
  },

  methods: {
    handleChangeMedia() {
      if (this.question.layout.video) {
        this.$emit('media-menu:change-media', 'video');
      } else {
        this.$emit('media-menu:change-media', 'image');
      }
    },
    handleRemoveMedia() {
      this.$emit('media-menu:remove-media', 'image');
    },
    handleSetAlignment(alignment) {
      this.$emit('media-menu:set-alignment', alignment);
    },
  },
};
</script>

<style scoped lang="scss">
.Media-menu {
  position: absolute;
  width: 134px;
  padding: 6px 11px;
  border-radius: 6px;
  max-height: 400px;
  background: white;
  border: 1px solid lightgrey;
  z-index: 5;
  top: 30px;

  .Selected {
    border-color: #046ff0;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
  }
  li {
    cursor:pointer;
    text-align: center;
    margin: 5px 0;
    font-size: 0.9rem;
  }
  .Icon {
    margin-right: 6px;
  }

  .RemoveMedia {
    color: #DB3A46;
    margin-top: 0;
  }

}
</style>
